__turbopack_context__.v({
  "h1": "text-module-sass-module__CJUPia__h1",
  "h2": "text-module-sass-module__CJUPia__h2",
  "loading": "text-module-sass-module__CJUPia__loading",
  "p": "text-module-sass-module__CJUPia__p",
  "pAccent": "text-module-sass-module__CJUPia__pAccent",
  "pBold": "text-module-sass-module__CJUPia__pBold",
});
